module.exports = __webpack_public_path__ + "static/img/bg-es.0cf35913.png";